export default __webpack_public_path__ + "static/media/fluent_calendar-clock-24-regular.711efee5.svg";